// extracted by mini-css-extract-plugin
export default {"profile-data":"Activity_profile-data__8Iu32","Activity-feed":"Activity_Activity-feed__n9iNt"};